export default __webpack_public_path__ + "static/media/SharpSans-medium.def47df9.otf";